import { } from "jquery"
import { Asset, Tablet, Dict } from "../api/model"
import { AssetApi, AssetLoanApi, FileApi } from "../api/api"
import { UiUtils, JqElm } from "./ui"
import { AssetPageBase, AssetBasicDataProvider } from "./asset_page_base"
import { HouseKeeperHelper } from "./house_keeper_helper"

export type SignatureStatus = "not_available" | "none" | "ok"

export class AssetLoanPageBase extends AssetPageBase {

    protected signatureBtn: JqElm
    protected signatureArea: JqElm
    protected signaturePreview: JqElm
    protected signaturePreviewImg: JqElm
    protected finalTabletSuccessElm: JqElm
    protected tabletNameElm: JqElm
    protected popupBackgroundElm: JqElm
    protected gotoStep3Elm: JqElm
    protected reloadElm: JqElm
    protected resultTableElm: JqElm
    protected finalAlertElm: JqElm
    protected currentTablet?: Tablet
    protected webCamStatus: boolean = false
    protected assetMap: Dict<Asset> = {}
    protected signatureStatus: SignatureStatus = "not_available"
    protected uploadTask: object
    protected lockPictureButton: boolean

    constructor(
        assetApi: AssetApi,
        protected assetLoanApi: AssetLoanApi,
        private houseKeeperHelper: HouseKeeperHelper,
        protected fileApi: FileApi,
        assetBasicDataProvider: AssetBasicDataProvider
    ) {
        super(assetApi, assetBasicDataProvider)
    }

    updateBackPageLink() {
        $('#backpage').prop('href', 'assetMain.aspx')
    }

    updateUserAuthMethod() {
        const userTypeElms = $("#wizardContent1 .useType")
        const val = $("#pluginRule").val()
        if (val == "1") {
            userTypeElms.eq(3).show()
            userTypeElms.eq(2).hide()
        } else {
            userTypeElms.eq(2).show()
            userTypeElms.eq(3).hide()
        }
    }

    private toggleSignatureUi(toggle: boolean) {
        if (toggle) {
            this.signatureStatus = "none"
            this.enableSignatureBtn()
        } else {
            this.signatureStatus = "not_available"
            this.disableSignatureBtn()
        }
        this.signatureArea.toggle(toggle)
        this.signaturePreview.toggle(toggle)
    }

    private enableSignatureBtn() {
        UiUtils.setDisabled(this.signatureBtn.removeClass('disabled'), false)
    }

    private disableSignatureBtn() {
        UiUtils.setDisabled(this.signatureBtn.addClass('disabled'), true)
    }

    initUiElements() {
        this.signaturePreview = $("#divSign")
        this.signaturePreviewImg = $('#imgHandWrite')
        this.signatureArea = $("#divHandWrite")
        this.signatureBtn = $('#showHandWrite')
        this.tabletNameElm = $('.tablet_name')
        this.finalTabletSuccessElm = $('.tablet_success')
        this.popupBackgroundElm = $("#popupBackground")
        this.gotoStep3Elm = $('.gotostep3')
        this.reloadElm = $('.reload')
        this.resultTableElm = $('#asset_mgt_result_table')
        this.finalAlertElm = $('.final-alert')
        var task = [{ folder: "webcam", displayName: "影像紀錄" }, { folder: "handwrite", displayName: "簽名版" }];
        this.uploadTask = new (<any>window).uploadToFirebaseStorage(task);
        this.lockPictureButton = false;
    }

    initWebCam() {
        const Webcam = (<any>window).Webcam
        const page = this
        Webcam.set({
            width: 230,
            height: 150,
            dest_width: 230,
            dest_height: 150,
            image_format: 'png',
            jpeg_quality: 90,
            force_flash: false,
            flip_horiz: false,
            fps: 45
        })
        Webcam.attach('#webCam')
        Webcam.on('error', function (err: string) {
            page.webCamStatus = false
            // console.error("Webcam error:%s", err)
            let img = $('#webCam img').show()
            if (img.length == 0) {
                img = $('<img>').prop('src', '../images/non-webcam.jpg')
                $('#webCam').append(img)
            }
            $("#webCam video").hide()
        })
        Webcam.on('live', function () {
            // console.log("WC live")
            page.webCamStatus = true
            $("#webCam img").hide()
            $("#webCam video").show()
        })
        page.listenF8WebCam()
        $('#manualPicture').click(e => {
            this.takePicture()
        })
    }

    dataUriToBlob(dataUri: string): Blob {
        //Reference - https://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
        //if (dataURI.split(',')[0].indexOf('base64') >= 0)
        const byteString = atob(dataUri.split(',')[1]);
        //else
        //    byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], { type: mimeString });
    }

    protected async getWebCamFileName(): Promise<string> {
        const imgSrc = $("#imgCapture").attr('src')
        if (this.webCamStatus && imgSrc != null && imgSrc.length > 0) {
            const file = this.dataUriToBlob(imgSrc)
            // console.log("File size:%s - type:%s", file.size, file.type)
            const uploadResult = await this.fileApi.uploadWebCam(file)
            return uploadResult.data.fileName
        } else {
            return Promise.resolve(null)
        }
    }

    protected async getSignatureFileName(): Promise<string> {
        const imgSrc = $('#imgHandWrite').prop('src')
        if (this.signatureStatus == 'ok') {
            const file = this.dataUriToBlob(imgSrc)
            // console.log("File size:%s - type:%s", file.size, file.type)
            const uploadResult = await this.fileApi.uploadSignature(file)
            return uploadResult.data.fileName
        } else {
            return Promise.resolve(null)
        }
    }

    private takePicture() {
        // console.log("Do take pic:%s", this.webCamStatus)
        const Webcam = (<any>window).Webcam
        Webcam.set({
            width: 230,
            height: 150,
            dest_width: 230,
            dest_height: 150,
            image_format: 'jpeg',
            jpeg_quality: 90,
            fps: 45
        });
        const that = this

        if (that.lockPictureButton == false) {
            $("#manualPicture").button("loading");
            that.lockPictureButton = true;
        }
        else {
            return;
        }

        if (this.webCamStatus) {
            Webcam.snap(function (dataUri: string) {
                $("#imgCapture").attr("alt", "上傳中...").attr("src", "");
                (<any>that.uploadTask).getTask("webcam").upload(dataUri).then(function (snapshot: object) {
                    //上傳成功 setTimeout防止連續拍照(firebase不允許短時間內多次上傳)
                    setTimeout(function () {
                        $("#imgCapture").attr("src", dataUri).attr("alt", "");
                        $("#theEnd").show();
                        $("#manualPicture").button("reset");
                        that.lockPictureButton = false;
                    }, 500);
                }).catch(function () {
                    //上傳失敗 setTimeout防止連續拍照(firebase不允許短時間內多次上傳)
                    setTimeout(function () {
                        $("#imgCapture").attr('src', '').attr("alt", "上傳失敗，請嘗試重新拍照");
                        $("#manualPicture").button("reset");
                        that.lockPictureButton = false;
                    }, 500);
                });
            })
        }
        else {
            // console.log("No pc")
            $(".webcamPhotoDiv .loading").hide()
            $("#theEnd").show()
        }
    }

    listenSignatureClick() {
        this.signatureBtn.click(e => {
            this.showSignatureBoard()
        })
    }

    /*
    private listenTabletBtnClick(){
        this.tabletBtn.click(e => {
            this.showTabletSelector(false)
        })
    }*/

    protected gotoStep(step: number) {
        $(`.panel-tab a[href*=wizardContent${step}]`).click()
    }

    protected processSignatureResult(signUrl: string) {
        if (signUrl != null && signUrl.startsWith('data:image/png;base64')) {
            this.signatureStatus = "ok"
            this.signaturePreviewImg.attr('src', signUrl)

            var that = this;

            that.signaturePreviewImg.attr("alt", "上傳中...").attr("src", "");
            (<any>that.uploadTask).getTask("handwrite").upload(signUrl).then(function (snapshot: object) {
                //上傳成功
                that.signaturePreviewImg.attr("src", signUrl).attr("alt", "");
            }).catch(function () {
                //上傳失敗
                that.signaturePreviewImg.attr('src', '').attr("alt", "上傳失敗，請嘗試重新上傳");
            });

        } else {
            this.signaturePreviewImg.attr('src', '')
            this.signatureStatus = "none"
        }
    }

    private processAppCodeScanResult(code: string) {
        this.popupBackgroundElm.hide()
        this.houseKeeperHelper.checkAppCode(code).then(tablet => {
            if (tablet != null) {
                this.toggleSignatureUi(false)
                this.updateTablet(tablet)
            }
        })
    }

    private listenF8WebCam() {
        $(document).keyup(e => {
            if (e.keyCode == 119) {
                this.takePicture()
            }
        })
    }

    private processCarrierScanResult(code: string) {
        this.popupBackgroundElm.hide()
        this.houseKeeperHelper.checkCarrier(code).then(tablet => {
            if (tablet != null) {
                this.toggleSignatureUi(false)
                this.updateTablet(tablet)
            }
        })
    }

    private processTabletSelectResult(withSignature: boolean, tabletVal: string, tabletNote: string) {
        this.popupBackgroundElm.hide()
        if (tabletVal != '') {
            const tablet: Tablet = { id: tabletVal, note: tabletNote, commId: '' }
            this.toggleSignatureUi(withSignature)
            this.updateTablet(tablet)
        }
    }

    protected updateTablet(tablet: Tablet) {
        //console.log("Update tablet:%s - %s", tablet.id, tablet.note)
        this.takePicture()
        this.currentTablet = tablet
        this.tabletNameElm.text(tablet.note)
        this.finalTabletSuccessElm.text(tablet.note)
    }

    private cleanTablet() {
        this.currentTablet = null
        this.tabletNameElm.text('尚未選擇戶別')
    }

    private showSignatureBoard() {
        (<any>window).fo._showMasterSignDiv(this.processSignatureResult.bind(this))
    }

    private showCarrierAuth() {
        (<any>window).fo._showMasterCarrierDiv(this.processCarrierScanResult.bind(this))
    }

    private showAppCodeScan() {
        (<any>window).fo._showMasterCodeDiv(this.processAppCodeScanResult.bind(this))
    }

    private showTabletSelector(withSignature: boolean) {
        (<any>window).fo._showMasterTabletDiv(this.processTabletSelectResult.bind(this, withSignature))
    }

    listenUserAuthClick() {

        //this.listenTabletBtnClick()
        $('.auth_by_direct').click(e => {
            this.showTabletSelector(false)
            this.popupBackgroundElm.show()
        })

        $('.auth_by_signature').click(e => {
            this.showTabletSelector(true)
            this.popupBackgroundElm.show()
        })

        $('.auth_by_carrier').click(e => {
            e.preventDefault()
            this.showCarrierAuth()
            this.popupBackgroundElm.show()
        })

        $('.auth_by_app_code').click(e => {
            e.preventDefault()
            this.showAppCodeScan()
            this.popupBackgroundElm.show()
        })
    }

    initNoteModal() {
        const page = this
        const modal = $('#note_ro_modal')
        const noteArea = $('#note_ro')
        modal.on('show.bs.modal', function (event) {
            const button = $(event.relatedTarget)
            const recordId = button.data('id')
            modal.data('id', recordId)
            const asset = page.assetMap[recordId]
            const note = asset.note ? asset.note.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''
            noteArea.html(note)
        })
    }

    toggleFinalElms(toggle: boolean) {
        this.finalAlertElm.toggle(toggle)
        this.finalTabletSuccessElm.toggle(toggle)
        this.resultTableElm.toggle(toggle)
        this.reloadElm.toggle(toggle)
    }
}